import * as React from "react";
import { cn } from "./cn";

type ContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  size?: "default" | "narrow" | "reading" | "wide";
};

const sizes = {
  default: "max-w-[1440px] px-4 md:px-6 lg:px-10",
  narrow: "max-w-3xl px-4 md:px-6",
  /** An article (components/news/NewsArticle.tsx): one reading column up to
   *  the laptop breakpoint, then text plus a 300 px sidebar. 1088 px at lg is
   *  the sum: a 35 em measure at 19 px (665) + the 40 px gap + 300 + 2 × 40 of
   *  padding — so the text fills its column instead of leaving a band. */
  reading: "max-w-3xl px-4 md:px-6 lg:max-w-[1088px] lg:px-10",
  wide: "max-w-screen-2xl px-4 md:px-6 lg:px-10",
};

export function Container({ size = "default", className, children, ...props }: ContainerProps) {
  return (
    <div className={cn("mx-auto w-full", sizes[size], className)} {...props}>
      {children}
    </div>
  );
}

export function Section({ className, children, ...props }: React.HTMLAttributes<HTMLElement>) {
  return (
    <section className={cn("py-16 md:py-20", className)} {...props}>
      {children}
    </section>
  );
}

export function SectionHeader({
  title,
  subtitle,
  action,
}: {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex items-end justify-between gap-6 mb-8 flex-wrap">
      <div>
        <h2>{title}</h2>
        {subtitle ? <p className="text-mid-gray mt-2 max-w-2xl">{subtitle}</p> : null}
      </div>
      {action ? <div>{action}</div> : null}
    </div>
  );
}
